import { render, staticRenderFns } from "./ProfessionSpecField.vue?vue&type=template&id=6e772ed5"
import script from "./ProfessionSpecField.vue?vue&type=script&lang=js"
export * from "./ProfessionSpecField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports